export default {
  /**
   * Set Teacher application approval list.
   *
   * @param state
   * @param items
   */
  setStaffLeaveApplicationApprovalList(state, items) {
    console.log("Items: ", items);
    state.items = items;
  },

  /**
   * Pagination.
   *
   * @param state
   * @param pagination
   */
  setStaffLeaveApplicationApprovalListPagination(state, pagination) {
    console.log("Pagination: ", pagination);
    state.pagination = pagination;
  },

  /**
   * Set current page.
   *
   * @param state
   * @param page
   */
  setStaffLeaveApplicationApprovalListPage(state, page) {
    state.pagination.current_page = page;
  },

  /**
   * Set filter.
   *
   * @param state
   * @param filter
   */
  setStaffLeaveApplicationListFilter(state, filter) {
    console.log(filter);

    state.filter = filter;
  },

  /**
   *
   * @param state
   * @param isBusy
   */
  setStaffLeaveApplicationListBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};
